import * as React from 'react';
import './Home.css';
import { ClassNames } from '../../_helpers/ClassNames';
import Image from '../Image/Image';
import { Link } from 'react-router-dom';

export type HomeItemProps = ProjectPreviewDto & { OneColumnLayout: boolean };

export class HomeItem extends React.Component<HomeItemProps> {
	constructor(props: HomeItemProps) {
		super(props);
	}

	render() {
		const { PreviewImage, PreviewLink, PageTitle, OneColumnLayout } =
			this.props;
		const sizes = OneColumnLayout
			? '100vw,(min-width: 1281px) 1300px'
			: `(max-width: 600px) 100vw, 
                    (min-width: 601px) and (max-width: 1280px) 45vw, 
                    (min-width: 1281px) 650px`;

		return (
			<article
				className={ClassNames('home', 'figure-container')}
				data-one-column={OneColumnLayout}
			>
				<figure className={ClassNames('home', 'figure')}>
					<Image
						pictureRef={PreviewImage}
						className={ClassNames('home', 'image')}
						sizes={sizes}
					/>
					{!OneColumnLayout && (
						<>
							<Link
								to={`/${PreviewLink}`}
								className={ClassNames('home', 'link')}
							/>
							<figcaption className={ClassNames('home', 'figcaption')}>
								{PageTitle}
							</figcaption>
						</>
					)}
				</figure>
				{OneColumnLayout && (
					<>
						<Link
							to={`/${PreviewLink}`}
							className={ClassNames('home', 'link')}
						/>
						<figcaption className={ClassNames('home', 'figcaption-one-column')}>
							{PageTitle}
						</figcaption>
					</>
				)}
			</article>
		);
	}
}
export default HomeItem;



// WEBPACK FOOTER //
// ./src/Components/Home/HomeItem.tsx